// extracted by mini-css-extract-plugin
export default {"skeleton":"skeleton_skeleton__dEXAd","shimmer":"skeleton_shimmer__Zv6rc"};